export default function MentorshipInfo({ email = "" }) {
  return <details className="af-mentorship">
    <summary>Mentorship <span aria-hidden="true">ⓘ</span><span className="af-sr-only">: what this includes</span></summary>
    <div className="af-mentorship-box"><p>Mentorship means you can email your fundraising professional to ask questions as you execute your strategy.</p>
      {email && <a className="af-secondary af-link-button" href={"mailto:" + email}>EMAIL MY FUNDRAISING PROFESSIONAL</a>}
    </div>
  </details>;
}
